import { RouterProvider } from "react-router-dom";
import { createBrowserRouter } from "@datadog/browser-rum-react/react-router-v6";
import { useRoutes } from "./useRoutes";

export const I18nRouter = () => {
  const defaultLang = "en-US";
  const routes = useRoutes(defaultLang);

  return <RouterProvider router={createBrowserRouter(routes)} />;
};
